import { DateTime } from "luxon";

import { fetcher } from "#app/http/fetcher";

export class NoMaterialLinesError extends Error {}

export const downloadMaterialConsultationCsv = async ({
  quoteRequestId,
  reference,
}: {
  quoteRequestId: string;
  reference: string | null | undefined;
}): Promise<void> => {
  const response = await fetcher.get(
    `/quote-requests/${quoteRequestId}/exports/material-consultation`,
    { responseType: "blob" },
  );

  if (response.status === 204) {
    throw new NoMaterialLinesError();
  }

  const blob = new Blob([response.data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  const formattedDate = DateTime.now().toFormat("yyyy-MM-dd");
  link.download = `${reference ?? "consultation"}-consultation-matiere-${formattedDate}.csv`;
  link.style.display = "none";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};
